import { styled, Dialog, dialogClasses, IconButton } from '@mui/material';
import { TabPanel } from '@mui/lab';

export const DialogAssociatePartnerCompanyContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 600,
    width: '100%',
  },
});

export const DialogAssociatePartnerCompanyTitle = styled('div')(
  ({ theme }) => ({
    flex: 'none',
    padding: theme.spacing(2, 3),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }),
);

export const DialogAssociatePartnerCompanyTitleCloseIcon = styled(IconButton)(
  ({ theme }) => ({
    color: theme.palette.grey[500],
  }),
);

export const DialogAssociatePartnerCompanyTabPanel = styled(TabPanel)({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  flex: 1,
});
